import { combineReducers } from 'redux';
import userData from './User';
import userCreds from './Global';

export default combineReducers({
  userData,
  userCreds,
});
